// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/jepx_settlement_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { BiddingBidMarket } from "./bidding_common_model_pb";
import { file_bffuser_v1_bidding_common_model } from "./bidding_common_model_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/jepx_settlement_model.proto.
 */
export const file_bffuser_v1_jepx_settlement_model: GenFile = /*@__PURE__*/
  fileDesc("CiZiZmZ1c2VyL3YxL2plcHhfc2V0dGxlbWVudF9tb2RlbC5wcm90bxIKYmZmdXNlci52MSKoAQoOSmVweFNldHRsZW1lbnQSLAoGbWFya2V0GAEgASgOMhwuYmZmdXNlci52MS5CaWRkaW5nQmlkTWFya2V0EhkKEXNldHRsZW1lbnRfbnVtYmVyGAIgASgJEioKD3NldHRsZW1lbnRfZGF0ZRgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSDQoFdGl0bGUYBCABKAkSEgoKYW1vdW50X3llbhgFIAEoAyJ2ChVKZXB4U2V0dGxlbWVudFN1bW1hcnkSLgoKc2V0dGxlbWVudBgBIAEoCzIaLmJmZnVzZXIudjEuSmVweFNldHRsZW1lbnQSLQoFaXRlbXMYAiADKAsyHi5iZmZ1c2VyLnYxLkplcHhTZXR0bGVtZW50SXRlbSLdAQoSSmVweFNldHRsZW1lbnRJdGVtEg0KBWxhYmVsGAEgASgJEisKCHF1YW50aXR5GAIgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbEgAiAEBEi0KCnVuaXRfcHJpY2UYAyABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsSAGIAQESEgoKYW1vdW50X3llbhgEIAEoAxIUCgxxdWFudGl0eV9yYXcYBSABKAkSFgoOdW5pdF9wcmljZV9yYXcYBiABKAlCCwoJX3F1YW50aXR5Qg0KC191bml0X3ByaWNlQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bffuser_v1_bidding_common_model, file_google_type_date, file_google_type_decimal]);

/**
 * JepxSettlement mirrors internalapi.v1.JepxSettlement for the frontend:
 * one 清算書 JEPX issued to the organization
 * (docs/specs/bidding/jepx-settlement.md §1)。 行の識別子は (market, settlement_number)。
 *
 * @generated from message bffuser.v1.JepxSettlement
 */
export type JepxSettlement = Message<"bffuser.v1.JepxSettlement"> & {
  /**
   * 清算書が属する市場。 間接送電権・定額制の清算書は BIDDING_BID_MARKET_SPOT。
   *
   * @generated from field: bffuser.v1.BiddingBidMarket market = 1;
   */
  market: BiddingBidMarket;

  /**
   * JEPX が採番した清算番号。 market と組で行を識別する。
   *
   * @generated from field: string settlement_number = 2;
   */
  settlementNumber: string;

  /**
   * 清算日。
   *
   * @generated from field: google.type.Date settlement_date = 3;
   */
  settlementDate?: Date;

  /**
   * 件名 (JEPX が発行した原文。 表示言語によらず変換しない)。
   *
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * 清算額 (円)。 JEPX の符号のまま: 負 = 会員が支払う、 正 = 会員が受け取る。
   *
   * @generated from field: int64 amount_yen = 5;
   */
  amountYen: bigint;
};

/**
 * Describes the message bffuser.v1.JepxSettlement.
 * Use `create(JepxSettlementSchema)` to create a new message.
 */
export const JepxSettlementSchema: GenMessage<JepxSettlement> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_model, 0);

/**
 * JepxSettlementSummary mirrors internalapi.v1.JepxSettlementSummary for the
 * frontend: one 清算書's 見出し and 明細 (AC-JST-007 の CSV の元)。
 *
 * @generated from message bffuser.v1.JepxSettlementSummary
 */
export type JepxSettlementSummary = Message<"bffuser.v1.JepxSettlementSummary"> & {
  /**
   * 見出し。 件名は JEPX の原文、 清算額は JEPX の符号のまま。
   *
   * @generated from field: bffuser.v1.JepxSettlement settlement = 1;
   */
  settlement?: JepxSettlement;

  /**
   * 明細の各行。 eSLJ が返した順。 0 件のこともある。
   *
   * @generated from field: repeated bffuser.v1.JepxSettlementItem items = 2;
   */
  items: JepxSettlementItem[];
};

/**
 * Describes the message bffuser.v1.JepxSettlementSummary.
 * Use `create(JepxSettlementSummarySchema)` to create a new message.
 */
export const JepxSettlementSummarySchema: GenMessage<JepxSettlementSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_model, 1);

/**
 * JepxSettlementItem mirrors internalapi.v1.JepxSettlementItem.
 *
 * @generated from message bffuser.v1.JepxSettlementItem
 */
export type JepxSettlementItem = Message<"bffuser.v1.JepxSettlementItem"> & {
  /**
   * 内容 (例: 売買手数料)。 JEPX の原文。
   *
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * 数量 (MWh)。 JEPX が数値として読める形で返した時だけ設定する。 桁区切り・単位なしで、
   * 小数の桁は JEPX のまま。 読めない値と "-" は quantity_raw、 空は両方とも未設定。
   *
   * @generated from field: optional google.type.Decimal quantity = 2;
   */
  quantity?: Decimal;

  /**
   * 単価 (円/MWh)。 数量と同じ扱い。
   *
   * @generated from field: optional google.type.Decimal unit_price = 3;
   */
  unitPrice?: Decimal;

  /**
   * 金額 (円)。 JEPX の符号のまま: 負 = 会員が支払う、 正 = 会員が受け取る。
   *
   * @generated from field: int64 amount_yen = 4;
   */
  amountYen: bigint;

  /**
   * 数量のうち数値として読めない値の原文。 JEPX が "-" で返した時も "-"。
   * quantity と同時には立たない。
   *
   * @generated from field: string quantity_raw = 5;
   */
  quantityRaw: string;

  /**
   * 単価のうち数値として読めない値の原文。 数量と同じ扱い。
   *
   * @generated from field: string unit_price_raw = 6;
   */
  unitPriceRaw: string;
};

/**
 * Describes the message bffuser.v1.JepxSettlementItem.
 * Use `create(JepxSettlementItemSchema)` to create a new message.
 */
export const JepxSettlementItemSchema: GenMessage<JepxSettlementItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_settlement_model, 2);

